/* global _DEBUG */

import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { ROUTE_BLOCKPAGE_CONTENT, ROUTE_BLOCK_WIDGET } from '../routeActions';
import { LoginMode } from './Login/constants';
import { selectLocationState } from '../location/selectors';
import { selectQuery } from '../location/selectors.web';

export const authSelector = (state) => state.Auth;

export const selectIsLoggedIn = createSelector(authSelector, (auth) => {
  return auth.get('currentUser') !== null;
});

/**
 * Much of the data available here is sourced from the DOM, and
 * therefore deprecated. See here for plans to refactor:
 * https://openlearning.atlassian.net/browse/DEV-70
 */
const HAS_WARNED = {
  // functionName: bool,
};

/**
 * TODO: Add a redux store with a mapping from courses the current user
 * is in to their current active cohort for that course.
 * The data selected here relies on the DOM
 */
export const currentCohortPathSelector = createSelector(
  selectLocationState,
  authSelector,
  (location, auth) => {
    if (
      location &&
      (location.type === ROUTE_BLOCKPAGE_CONTENT ||
        location.type === ROUTE_BLOCK_WIDGET)
    ) {
      return location.query.cohortpath;
    } else {
      return auth.get('currentCohort', '');
    }
  }
);

export const currentUserIdSelector = createSelector(authSelector, (auth) => {
  return auth.get('currentUser');
});

export const selectHasFetchedEnrolledClassData = createSelector(
  authSelector,
  (auth) => {
    return auth.get('hasFetchedEnrolledClassData');
  }
);

export const selectSSOContext = createSelector(authSelector, (auth) => {
  return auth.get('ssoContext');
});

export const selectSSOUserDefaultImg = createSelector(authSelector, (auth) => {
  return auth.get('ssoUserDefaultImg');
});

export const selectSignUpUserRequired = createSelector(authSelector, (auth) => {
  return auth.get('signUpUserRequired');
});

export const selectSSOPageTabView = createSelector(authSelector, (auth) => {
  return auth.get('ssoView');
});

export const selectSSOUserDetails = createSelector(authSelector, (auth) => {
  return auth.get('currentUserSSODetails');
});

export const selectHasRequestedEnrolledClassData = createSelector(
  authSelector,
  (auth) => {
    return (
      auth.get('hasFetchedEnrolledClassData') ||
      auth.get('numFetchingEnrolledClassData') > 0
    );
  }
);

export const selectInProgress = createSelector(authSelector, (auth) => {
  return auth.get('inProgress');
});

export const selectErrorMessage = createSelector(authSelector, (auth) => {
  return auth.get('errorMessage');
});

export const getLegacyToken = createSelector(authSelector, (auth) => {
  return auth.get('legacyToken');
});

export const customDomainCookieSelector = createSelector(
  authSelector,
  (auth) => {
    return auth.get('customDomain', Immutable.Map());
  }
);
export const authTokenSelector = createSelector(
  [getLegacyToken, customDomainCookieSelector],
  (legacyToken, customDomain) => {
    return Immutable.Map({
      legacyToken,
      customDomain,
    });
    // if (
    //   _.includes(
    //     [
    //       MAIN_DOMAIN,
    //       'help.openlearning.com',
    //     ],
    //     hostname
    //   )
    // ) {
    //   return legacyToken || 'Cookie: ""';
    // }
    // const cookie = customDomain.get(hostname, null);
    // return cookie;
  }
);
// export const makeAuthTokenSelectorByHostName = (hostname) =>
//   createSelector(
//     [getLegacyToken, customDomainCookieSelector],
//     (legacyToken, customDomain) => {
//       if (
//         _.includes(
//           [
//             MAIN_DOMAIN,
//             'help.openlearning.com',
//           ],
//           hostname
//         )
//       ) {
//         return legacyToken || 'Cookie: ""';
//       }
//       const cookie = customDomain.get(hostname, null);
//       return cookie;
//     }
//   );

/**
 * Returns a JS array of strings containing role names.
 * DEPRECATED DUE TO DOM DEPENDENCY
 * Instead use
 *  - ReduxStorage/CohortRoles/selectors.jsx:cohortRolesByCourseSelector
 * TODO: add selectors to select
 */
export const deprecatedGetCohortRoles = (state, cohortPath) => {
  if (_DEBUG) {
    if (!HAS_WARNED.deprecatedGetCohortRoles) {
      HAS_WARNED.deprecatedGetCohortRoles = true;

      // eslint-disable-next-line no-console
      console.error('isCourseAdmin is deprecated due to Django dependencies');
    }
  }
  const classRoles = state.Auth.getIn(['classRoles', cohortPath], false);

  if (!classRoles) {
    return [];
  }

  return classRoles.toJS();
};

export const selectCsrfToken = createSelector(authSelector, (auth) => {
  return auth.get('csrfToken', null);
});

export const institutionRolesSelector = createSelector(authSelector, (auth) =>
  auth.get('institutionRoles')
);

export const selectLastLoginDate = createSelector(authSelector, (auth) =>
  auth.get('lastLoginDate')
);

export const selectCurrentPortalName = createSelector(authSelector, (auth) =>
  auth.get('currentPortalName')
);

export const selectLoginMode = createSelector(authSelector, (auth) =>
  auth.get('loginMode')
);

export const selectLoginView = createSelector(
  authSelector,
  selectLoginMode,
  (auth, loginMode) => {
    return auth.get('forgotPassword') ? LoginMode.forgotPassword : loginMode;
  }
);

export const selectLastTokenRefreshedDate = createSelector(
  authSelector,
  (auth) => auth.get('lastTokenRefreshedDate')
);

export const selectLoginSignupViewMode = createSelector(selectQuery, (query) =>
  query.get('mode', LoginMode.login)
);

export const selectSignupVerificationCode = createSelector(
  selectQuery,
  (query) => query.get('verificationCode', null)
);
